import { render, staticRenderFns } from "./PolicyEscrow.vue?vue&type=template&id=3efee4b2&scoped=true"
import script from "./PolicyEscrow.vue?vue&type=script&lang=ts"
export * from "./PolicyEscrow.vue?vue&type=script&lang=ts"
import style0 from "./PolicyEscrow.vue?vue&type=style&index=0&id=3efee4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efee4b2",
  null
  
)

export default component.exports